import {
	$callapi,
} from '@/common/request';

/*
// lazy
{
	key: 'kk',
	timeout: 10, // s
	getter: async ($vue)=>{
		
	},
}
*/

function _api_getter({
	apiname,
	param,
	wrapper
}) {
	// console.log(apiname, param, wrapper)
	return async () => {
		let p = typeof (param) == 'function' ? param() : param
		let r = await $callapi(apiname, p)
		return r && r.data ? (wrapper ? wrapper(r.data) : r.data) : NOTDATA
	}
}

function _datadic_define({
	key,
	types
}) {
	return {
		key: key,
		timeout: 60 * 5,
		getter: _api_getter({
			apiname: 'getDataDicSet',
			param: {
				'types': types
			},
			wrapper: (data) => {
				// console.log(data)
				let ks = Object.keys(data)
				ks.map(k => {
					let mp = {}
					data[k].map(v => {
						mp[v.id] = v
					})
					data[k + '_map'] = mp
				})
				// console.log(data)
				return data
			}
		})
	}
}

const NOTDATA = '__NODATA__'
let _Lazy = {

}

export function defineLazy({
	key,
	timeout,
	getter
}) {
	// 声明懒加载
	let l = {
		key,
		timeout,
		getter,
	}
	l.data = NOTDATA
	_Lazy[key] = l
}

defineLazy(_datadic_define({
	key: 'datadic',
	name: '数据字典',
	types: 'color,level,norm,length,maturity,flaw,feature,unit,banktype,flightcompany,flighttype,flightport,countryareacode,replywords',
}))

defineLazy({
	key: 'classifyList',
	name: '分类列表',
	timeout: 60 * 5,
	getter: _api_getter({
		apiname: 'pre/getClassifyList',
		param: {
			'size': '-1'
		},
		wrapper: (data) => {
			return data ? data.items : NOTDATA
		}
	})
})

defineLazy({
	key: 'classifyData',
	name: '分类列表',
	timeout: 60 * 5,
	getter: async () => {
		let list = await getLazyData('classifyList')
		if (list != NOTDATA) {
			let map = {}
			list.map(c => {
				map[c.id] = c
			})
			return {
				list: list,
				map: map
			}
		}
		return NOTDATA
	}
})
defineLazy({
	key: 'setting',
	name: '平台设置',
	timeout: 60 * 5,
	getter: _api_getter({
		apiname: 'getSetting',
	})
})
defineLazy({
	key: 'NationalData',
	name: '设置信息',
	timeout: 60 * 5,
	getter: _api_getter({
		apiname: 'getNationalData',
	})
})

defineLazy({
	key: 'areasdata',
	name: '平台地址库',
	timeout: 60 * 60 * 24,
	getter: _api_getter({
		apiname: 'pre/getAreasData',
	})
})

defineLazy({
	key: 'hotkeywords',
	name: '热门搜索',
	timeout: 60 * 5,
	getter: _api_getter({
		apiname: 'getProductList',
		param: {
			'orderby': '-sales',
			'size': '3'
		},
		wrapper: (data) => {
			return data ? data.items.map((k) => { return k.name }) : NOTDATA
		}
	})
})

export function getLazyApiData(api_or_options) {
	let options = typeof (api_or_options) == 'string' ? { api: api_or_options } : api_or_options;
	let key = 'LAZY_API_' + options.api.split(/\//ig).join('_')
	if (!(key in _Lazy)) {
		defineLazy({
			key: key,
			name: options.api,
			timeout: options.timeout || 60 * 5,
			getter: _api_getter({
				apiname: options.api,
			})
		})
	}
	return getLazyData(key)
}

export async function getLazyData(key, force) {
	if (_Lazy[key] == undefined) {
		throw ("NOT Lazy: " + key)
	}
	let lz = _Lazy[key]
	let d = lz.data
	let last = lz.last || 0;
	if (!force && d != NOTDATA && ((Date.now() - last) / 1000) < (lz.timeout || 60)) {
		return d
	} else {
		// console.log(lz)
		try {
			let nd = await lz.getter()
			if (nd != NOTDATA) {
				lz.data = nd
				lz.last = Date.now()
				return nd
			} else {
				throw ("Lazy getter error: " + key)
			}
		} catch (e) {
			throw ("Lazy getter error: " + key + ', ' + e)
		}
	}
}


export default {
	install(Vue) {
		Vue.prototype.$lazy = async function (key, force) {
			// 懒加载数据
			return getLazyData(key, force);
		}
		Vue.prototype.$lazyApi = async function (api_or_options) {
			// 懒加载接口数据
			return getLazyApiData(api_or_options);
		}
	}
}